import { BookingStatus } from "@repo/database";
import { useTranslation } from "react-i18next";

import { useBooking } from "~/hooks/use-booking";
import { useTempBookingStore } from "~/stores/use-booking-store";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import PendingBookings from "./pending-bookings";

export default function PendingBookingsDialog() {
  const { t } = useTranslation("common");
  const { pendingBookingsOpen, setPendingBookingsOpen } = useTempBookingStore();

  const { bookings } = useBooking();

  const handleDialog = (open: boolean) => {
    setPendingBookingsOpen(open);
  };

  return (
    <Dialog open={pendingBookingsOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-2xl w-full">
        <DialogHeader>
          <DialogTitle>{t("Booking.pending_bookings")}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <PendingBookings
            onClose={() => {
              handleDialog(false);
            }}
            bookings={bookings.filter(
              (booking) => booking.bookingStatus === BookingStatus.pending,
            )}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
